export const LABA_RUGI_GET_REQUEST = "LABA_RUGI_GET_REQUEST";
export const LABA_RUGI_GET_SUCCESS = "LABA_RUGI_GET_SUCCESS";
export const LABA_RUGI_GET_FAIL = "LABA_RUGI_GET_FAIL";
export const LABA_RUGI_GET_RESET = "LABA_RUGI_GET_RESET";

export const LABA_RUGI_GENERATE_REQUEST = "LABA_RUGI_GENERATE_REQUEST";
export const LABA_RUGI_GENERATE_SUCCESS = "LABA_RUGI_GENERATE_SUCCESS";
export const LABA_RUGI_GENERATE_FAIL = "LABA_RUGI_GENERATE_FAIL";
export const LABA_RUGI_GENERATE_RESET = "LABA_RUGI_GENERATE_RESET";
